import Button, { ButtonProps } from '@material-ui/core/Button';
import styled from 'styled-components';
// eslint-disable-next-line
import React from 'react';

const BackButton = styled(Button)`
  border: 1px solid transparent;
`;

export type Props = ButtonProps;

const GoBackButton: React.FC<Props> = ({ children, ...props }) => {
  return (
    <BackButton
      size="medium"
      variant="outlined"
      color="primary"
      data-testid="go-back-btn"
      {...props}
    >
      {children || 'VOLVER'}
    </BackButton>
  );
};

export default GoBackButton;
